import React from 'react'
import isNil from 'lodash/isNil'
import _get from 'lodash/get'
import { Map } from 'immutable'
import { useSelector } from 'react-redux'
import { useTranslation } from '../../../services/static-text/hooks'
import { selectPrimaryLanguage } from '../../../services/user/selectors'
import {
  selectGiftSku,
  selectGiftPlan,
  selectUserCanPurchaseGift,
  selectUserCanPurchaseGiftMultipleCurrency,
} from '../../../services/gift/selectors'
import { selectAuth } from '../../../services/auth/selectors'
import { usePaymentSetupErrorKey } from '../../../services/gift/hooks'
import { useGetPlanGridData } from '../../../services/plans/hooks'
import { BILLING_PLAN_GRID_LOCATION_GIFT } from '../../../services/plans/utils'
import { GIFT_READY_STATE } from '../../../services/gift/index'
import { get as getConfig } from '../../../config/index'
import GiftPlaceholder, { TYPES } from '../GiftPlaceholder/index'
import { Errors } from './Errors'
import { GiftLayout } from '../GiftLayout'
import { GiftSelection } from '../GiftSelection'
import { GIFT_PAYMENT_PAGE_STATIC_KEY } from './gift-payment-page-static-key'
import { CreditCardPayment } from './CreditCardPayment'

const config = getConfig()
const planGraphQLActive = !!_get(config, ['features', 'checkout', 'planGraphQL'])
const giftMultipleCurrenciesActive = !!_get(config, ['features', 'gift', 'multipleCurrencies'])

const PaymentOptions = (props) => {
  const { selectedPlan } = props
  const translateByKey = useTranslation(GIFT_PAYMENT_PAGE_STATIC_KEY)
  const errorKey = usePaymentSetupErrorKey()
  const isError = !isNil(errorKey)

  return (
    <>
      {isError ? (
        <div className="payment-body__error">
          <Errors errorKey={errorKey} />
        </div>
      ) : null}
      <div className="gift-payment-page__choose-payment">{translateByKey('pleaseSelectPayment')}</div>
      <CreditCardPayment selectedPlan={selectedPlan} />
    </>
  )
}

export const GiftPaymentPage = () => {
  const auth = useSelector(selectAuth)
  const authJwt = auth.get('jwt')
  const userLanguage = useSelector(selectPrimaryLanguage)
  const translateByKey = useTranslation(GIFT_PAYMENT_PAGE_STATIC_KEY)
  const canPurchaseGift = useSelector(
    giftMultipleCurrenciesActive
      ? selectUserCanPurchaseGiftMultipleCurrency
      : selectUserCanPurchaseGift,
  )
  let selectedPlan = useSelector(selectGiftPlan)
  const sku = useSelector(selectGiftSku)
  const formattedPlans = useGetPlanGridData({
    userLanguage,
    authJwt,
    page: BILLING_PLAN_GRID_LOCATION_GIFT,
  })

  const pageReady = !isNil(sku) && !isNil(selectedPlan)

  if (planGraphQLActive) {
    selectedPlan = formattedPlans.find((gp) => gp.get('sku') === sku) || Map()
  }

  if (planGraphQLActive && (!selectedPlan || (Map.isMap(selectedPlan) && !selectedPlan.size))) {
    return (
      <GiftLayout
        pageReady={pageReady}
        pageTitle={translateByKey('title')}
        restricted={canPurchaseGift !== GIFT_READY_STATE.CAN_PURCHASE}
        main={
          <div style={{ width: '90%' }}>
            <GiftPlaceholder type={TYPES.SMALL} />
            <GiftPlaceholder type={TYPES.MEDIUM} />
            <GiftPlaceholder type={TYPES.MEDIUM} />
            <GiftPlaceholder type={TYPES.SMALL} />
          </div>
        }
        rightSide={
          <div style={{ width: '80%', margin: '0px auto' }}>
            <GiftPlaceholder type={TYPES.SMALL} />
            <GiftPlaceholder type={TYPES.SMALL} />
            <GiftPlaceholder type={TYPES.LARGE} />
          </div>
        }
      />
    )
  }

  return (
    <GiftLayout
      pageReady={pageReady}
      pageTitle={translateByKey('title')}
      restricted={!canPurchaseGift}
      rightSide={
        <GiftSelection
          canPurchaseGift={canPurchaseGift}
          selectedPlan={selectedPlan}
          showMobileTitle={false}
          planData={formattedPlans}
          changeable
        />
      }
      main={<PaymentOptions selectedPlan={selectedPlan} />}
    />
  )
}

export default GiftPaymentPage
